<template>
	<div class="gray-line" />
</template>

<script>
export default {
	name: 'HorizontalSeparator',
};
</script>
